import { render, staticRenderFns } from "./SidebarTask.vue?vue&type=template&id=3068f82a&"
import script from "./SidebarTask.vue?vue&type=script&lang=js&"
export * from "./SidebarTask.vue?vue&type=script&lang=js&"
import style0 from "./SidebarTask.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports